export default __webpack_public_path__ + "static/media/notification-color-icon.e90167f2.svg";